import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import LoadingPage from "./LoadingPage";
import PageEight from "./PageEight";

const PageSeven = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [themeRecommended, SetThemeRecommended] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_SEVEN, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Seven", error);
                });

            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Seven ", responseAPI);
                    console.log("====================================");

                    SetThemeRecommended(responseAPI.listRekomandasiTemaProject);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={500} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <LabelTitle label={"Rekomendasi Tema Project Pembelajaran Profil Pelajar Pancasila"} size={18} bolder={500} color={"#212529"} />
                        <LabelTitle
                            label={"Dari hasil asesmen terkait survei karakter siswa berdasarkan aspek Profil Pelajar Pancasila, maka disarankan untuk melakukan Project Based Learning dengan urutan tema sebagai berikut:"}
                            size={14}
                            bolder={400}
                            color={"#212529"}
                        />
                        <Gap height={5} />
                        <GridInline width={"100%"}>
                            <GridInline width={"21%"}>
                                <GridInline width={"25%"}>
                                    <img src="/assets/image/pemetaan/Strongly.png" width={30} />
                                </GridInline>
                                <GridInline>
                                    <LabelTitle label={"Strongly Recommended"} size={14} bolder={500} color={"#6C757D"} />
                                </GridInline>
                            </GridInline>
                            <GridInline width={"5%"} />
                            <GridInline width={"21%"}>
                                <GridInline width={"25%"}>
                                    <img src="/assets/image/pemetaan/Recommended.png" width={30} />
                                </GridInline>
                                <GridInline>
                                    <LabelTitle label={"Recommended"} size={14} bolder={500} color={"#6C757D"} />
                                </GridInline>
                            </GridInline>
                            <GridInline width={"21%"}>
                                <GridInline width={"25%"}>
                                    <img src="/assets/image/pemetaan/Poorly.png" width={30} />
                                </GridInline>
                                <GridInline>
                                    <LabelTitle label={"Poorly Recommended"} size={14} bolder={500} color={"#6C757D"} />
                                </GridInline>
                            </GridInline>
                        </GridInline>
                        <Gap height={20} />
                        <div className="rekap-table">
                            <Table striped size="sm" style={{ fontSize: 12 }}>
                                <thead
                                    style={{
                                        backgroundColor: "#E9ECEF",
                                        fontSize: 12,
                                        textAlign: "center",
                                    }}
                                >
                                    <tr>
                                        <th width="25%" height="50">
                                            Team Project
                                        </th>
                                        <th width="25%">Sasaran Profil Pelajar Pancasila</th>
                                        <th width="25%">Contoh Implementasi</th>
                                        <th width="25%">Rekomendasi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {themeRecommended.map((theme, i) => {
                                        return (
                                            <tr
                                                key={i}
                                                height="40"
                                                style={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                <td>
                                                    <img
                                                        src={"/assets/image/pemetaan/tema/" + theme.imageTema + ".png"}
                                                        width={30}
                                                        style={{
                                                            marginBottom: 5,
                                                            marginTop: 5,
                                                        }}
                                                    />
                                                    <LabelTitle label={theme.tema} size={11} bolder={400} color={"#6C757D"} />
                                                </td>
                                                <td>
                                                    <img
                                                        src={"/assets/image/pemetaan/tema/" + theme.imageSasaran + ".png"}
                                                        width={30}
                                                        style={{
                                                            marginBottom: 5,
                                                            marginTop: 5,
                                                        }}
                                                    />
                                                    <LabelTitle label={theme.sasaran} size={11} bolder={400} color={"#6C757D"} />
                                                </td>
                                                <td>
                                                    <LabelTitle label={theme.implementasi} size={11} bolder={400} color={"#6C757D"} />
                                                </td>
                                                <td>
                                                    <img
                                                        src={"/assets/image/pemetaan/" + theme.rekomendasi + ".png"}
                                                        width={30}
                                                        style={{
                                                            marginBottom: 5,
                                                            marginTop: 5,
                                                        }}
                                                    />
                                                    <LabelTitle label={theme.rekomendasi} size={11} bolder={400} color={"#6C757D"} />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <Gap height={40} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div>
            </div>

            {openPage ? <PageEight idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
        </div>
    );
};

export default PageSeven;
